import {CreditPack, PackRecommendation, RideSelection} from "pages/Front/Booking/Credits/CreditCalculator/types";
import {CREDIT_PACKS, MAX_RIDE_CREDITS, MIN_RIDE_CREDITS, RIDES} from "pages/Front/Booking/Credits/CreditCalculator/constants";

const chfFormatter = new Intl.NumberFormat("de-CH", {
    style: "currency",
    currency: "CHF",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function formatChf(value: number): string {
    return chfFormatter.format(value);
}

export function formatPricePerCredit(pack: CreditPack): string {
    return chfFormatter.format(pack.priceChf / pack.credits);
}

/** "Reicht für" range: fewest rides (all expensive) to most rides (all cheap). */
export function rideRange(pack: CreditPack): {min: number; max: number} {
    return {
        min: Math.floor(pack.credits / MAX_RIDE_CREDITS),
        max: Math.floor(pack.credits / MIN_RIDE_CREDITS),
    };
}

export function totalCreditsNeeded(selection: RideSelection): number {
    return RIDES.reduce((sum, ride) => sum + ride.credits * selection[ride.id], 0);
}

/** Smallest pack covering the need; null when need is 0 or exceeds the ladder. */
export function findRecommendation(creditsNeeded: number): PackRecommendation | null {
    if (creditsNeeded <= 0) return null;
    const pack = CREDIT_PACKS.find(p => p.credits >= creditsNeeded);
    if (!pack) return null;
    return {pack, surplus: pack.credits - creditsNeeded};
}

export function exceedsLargestPack(creditsNeeded: number): boolean {
    const largest = CREDIT_PACKS[CREDIT_PACKS.length - 1];
    return creditsNeeded > largest.credits;
}

export function emptySelection(): RideSelection {
    return {"go-kart": 0, "zosh-super-drift": 0, "crazy-drift": 0};
}
